import { useBusinessContext } from '@root/context'
import { useQuery } from '@tanstack/react-query'
import { BusinessIdentifier, fetchAllBusinessIdentifiers } from '../businessIdentifiers'

export const useBusinessIdentifiers = () => {
  const { slug } = useBusinessContext()

  return useQuery<BusinessIdentifier[]>({
    queryKey: [slug, 'businessIdentifiers'],
    queryFn: () => fetchAllBusinessIdentifiers({ slug }),
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    enabled: Boolean(slug)
  })
}
